import { GATEWAY_FETCH_TIMEOUT_MS } from '@/core/const/gatewayFetchTimeoutMs.const'

import { mapGatewayFetchError } from './mapGatewayFetchError'

export async function fetchGateway(url: string): Promise<Response> {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), GATEWAY_FETCH_TIMEOUT_MS)

  try {
    return await fetch(url, {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
  } catch (error) {
    throw mapGatewayFetchError(error)
  } finally {
    clearTimeout(timeoutId)
  }
}
